import React, { useEffect, useState } from "react";
import { useCreateConsentMasterMutation } from "../../../Services/vehicle/Vehicle";
import useThemeColors from "../ThemeColors";
import { toast } from "react-toastify";

interface IPROPS {
  closeModal: any;
  refetch: any;
}

const CreateConsentMaster: React.FC<IPROPS> = ({ closeModal, refetch }) => {
  const [name, setName] = useState("");
  const [consentId, setConsentId] = useState("");
  // const [consentCategory,setConsentCategory] = useState('')
  // const [promotionalCategory,setPromotionalCategory] = useState('')
  const [mandatoryCategory, setMandatory] = useState("");
  const [desc, setDesc] = useState("");

  const [createMasterLoader, setCreateMasterLoader] = useState(false);
  const [createConsentMasterTrigger, { status }] =
    useCreateConsentMasterMutation();

  useEffect(() => {
    if (status === "pending") {
      setCreateMasterLoader(true);
    } else {
      setCreateMasterLoader(false);
    }
  }, [status]);

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const saveConsentMaster = async () => {
    const payload = {
      name: name, // Required, max length 255
      code: consentId, // Required, max length 50, must be unique
      description: desc, // Optional
      is_mandatory: mandatoryCategory,
      is_active: "true",
    };
    const response = await createConsentMasterTrigger(payload);

    try {
      if (response?.data) {
        closeModal();
        toast.success("Consent saved successfully");
        refetch();
      }
    } catch (error) {
      toast.error("An error occured");
    }
  };

  return (
    <div>
      <div
        className="vehicle-info-middle"
        style={{
          boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
          borderRadius: "40px",
        }}
      >
        <div
          className="vehicle-info-middle-heading"
          style={{
            borderBottom: "1px solid #C7C8CA",
            padding: "15px 30px",
            color: "#666666",
            fontSize: "24px",
            fontFamily: "karbon",
          }}
        >
          Consent
        </div>
        <div
          className="vehicle-info"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px 15px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              padding: "10px 30px",
            }}
          >
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontFamily: "karbon",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Name
                </span>
                <span>
                  <input
                    style={{
                      borderRadius: "20px",
                      background: "#FCFCFC",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                    className="form-control"
                    type="text"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    placeholder="Name"
                  />
                </span>
              </p>
            </div>

            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Consent type
                </span>
                <span>
                  {/* <input
                                    style={{
                                        borderRadius: "20px",
                                        background: "#FCFCFC",
                                    }}
                                    className="form-control"
                                    type="text"
                                    onChange={(e) =>
                                        setConsentId(e.target.value)
                                    }
                                    value={consentId}
                                    placeholder="Consent code"
                                /> */}

                  <select
                    value={consentId}
                    onChange={(e) => setConsentId(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option>Select an option</option>
                    <option value="service notification">
                      Service notification
                    </option>
                    <option value="promotional offers">
                      Promotional offers
                    </option>
                    <option value="feedback request">Feedback request</option>
                  </select>
                </span>
              </p>
            </div>
            {/* <div style={{ width: "100%" }}>
                        <p className="vehicle-class" style={{display: "flex", flexDirection: "column"}}>
                            <span className="required" style={{ paddingLeft: "10px", marginBottom: "10px" }}>Consent Category</span>
                            <span>
                                  <select onChange={(e) => setConsentCategory(e.target.value)} style={{background: "#FCFCFC", width: "100%", borderRadius: "30px", padding: "12px"}}>
                                    <option>Select</option>
                                    <option value="true">Yes </option>
                                    <option value="false">No</option>
                                </select>
                            </span>
                        </p>
                    </div>  */}
            {/* <div style={{ width: "100%" }}>
                        <p className="vehicle-class" style={{display: "flex", flexDirection: "column"}}>
                            <span className="required" style={{ paddingLeft: "10px", marginBottom: "10px" }}>Promotional</span>
                            <span>
                                <select onChange={(e) => setPromotionalCategory(e.target.value)} style={{background: "#FCFCFC", width: "100%", borderRadius: "30px", padding: "12px"}}>
                                    <option>Select</option>
                                    <option value="true">Yes </option>
                                    <option value="false">No</option>
                                </select>
                    
                            </span>
                        </p>
                    </div>  */}
            <div style={{ width: "100%" }}>
              <p
                className="vehicle-class"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "10px",
                    fontFamily: "karbon",
                    color: "#666666",
                  }}
                >
                  Mandatory
                </span>
                <span>
                  <select
                    value={mandatoryCategory}
                    onChange={(e) => setMandatory(e.target.value)}
                    style={{
                      background: "#FCFCFC",
                      width: "100%",
                      borderRadius: "30px",
                      padding: "12px",
                      fontFamily: "karbon",
                      color: "#666666",
                    }}
                  >
                    <option>Select an option</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {/* <input
                                    style={{
                                        borderRadius: "20px",
                                        background: "#FCFCFC",
                                    }}
                                    className="form-control"
                                    type="text"
                                    onChange={(e) =>
                                        setConsentId(e.target.value)
                                    }
                                    value={consentId}
                                    placeholder="Add brand"
                                /> */}
                </span>
              </p>
            </div>
          </div>
          <div style={{ padding: "10px 30px" }}>
            <textarea
              value={desc}
              onChange={(e) => {
                const lettersOnly = e.target.value.replace(/[^a-zA-Z\s]/g, "");

                setDesc(lettersOnly);
              }}
              placeholder="Enter description"
              style={{
                width: "100%",
                borderRadius: "40px",
                padding: "10px 20px",
                background: "#FFF1EC",
                border: "none",
                fontFamily: "karbon",
                color: "#666666",
              }}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <button
              onClick={saveConsentMaster}
              // onClick={createVehicleDataHandler}
              // disabled={!brandName.trim()}
              style={{
                // background:!consentId.trim() ?  "#F7D3C5" :  `${selectedButtonBackgoundColors}`,
                background: `${selectedButtonBackgoundColors}`,
                color: `${selectedButtonColors}`,
                border: "none",
                padding: "10px 20px",
                borderRadius: "20px",
                fontSize: "15px",
                fontFamily: "karbon",
                //    cursor: consentId.trim() ? "pointer" : "not-allowed",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateConsentMaster;
